import { Typography } from 'modules/Typography';
import { Mark, Step, StepBody, StepSource } from '../styled';
export function AgenticPathStep(props) {
    const { icon, label, detail, source } = props;
    return (<Step>
      <Mark>{icon}</Mark>
      <StepBody>
        <Typography $fontSize="small" $fontWeight="medium" $color="swatches.warm.500">
          {label}
        </Typography>
        {detail && (<Typography $fontSize="tiny" $color="swatches.warm.500">
            {detail}
          </Typography>)}
        {source && (<StepSource $fontSize="tiny" $color="swatches.warm.500">
            {source}
          </StepSource>)}
      </StepBody>
    </Step>);
}
